import { Button, Form } from 'antd';

import styles from './ExperienceConfigurationFooter.module.scss';

type ExperienceConfigurationFooterProps = {
  handleClose: () => void;
  handleSave: () => void;
  isLoading?: boolean;
};

export const ExperienceConfigurationFooter = ({
  handleClose,
  handleSave,
  isLoading,
}: ExperienceConfigurationFooterProps) => {
  const form = Form.useFormInstance();

  return (
    <div className={styles.footer}>
      <Form.Item shouldUpdate>
        {() => (
          <>
            <Button size="large" type="ghost" onClick={handleClose} key="back">
              Cancel
            </Button>
            <Button
              key="save"
              size="large"
              type="primary"
              onClick={handleSave}
              disabled={
                !!form.getFieldsError().filter(({ errors }) => errors.length)
                  .length
              }
              loading={isLoading}
            >
              Save
            </Button>
          </>
        )}
      </Form.Item>
    </div>
  );
};
